import InitialsAvatar from "./initials-avatar";


export default function UserAvatar({ user, width, ...props}) {
  return (
    <>

       <InitialsAvatar user={user} width={width} {...props} />
    </>
  );
}
